"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ColumnMappingSelect;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _editor = require("../../../components/visualizations/editor");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MappingTypes = {
  x: {
    label: "X Column"
  },
  y: {
    label: "Y Columns",
    multiple: true
  },
  series: {
    label: "Group by"
  },
  yError: {
    label: "Errors column"
  },
  size: {
    label: "Bubble Size Column"
  },
  zVal: {
    label: "Color Column"
  }
};

function ColumnMappingSelect(_ref) {
  var value = _ref.value,
      availableColumns = _ref.availableColumns,
      type = _ref.type,
      _onChange = _ref.onChange;
  var options = (0, _lodash.sortBy)((0, _lodash.filter)((0, _lodash.uniq)((0, _lodash.flatten)([availableColumns, value])), v => (0, _lodash.isString)(v) && v !== ""));
  var _MappingTypes$type = MappingTypes[type],
      label = _MappingTypes$type.label,
      multiple = _MappingTypes$type.multiple;
  return /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Select, {
    label: label,
    "data-test": "Chart.ColumnMapping.".concat(type),
    mode: multiple ? "multiple" : "default",
    allowClear: true,
    showSearch: true,
    placeholder: multiple ? "Choose columns..." : "Choose column...",
    value: value || undefined,
    onChange: column => _onChange(column || null, type)
  }, (0, _lodash.map)(options, c => /*#__PURE__*/_react.default.createElement(_editor.Select.Option, {
    key: c,
    value: c,
    "data-test": "Chart.ColumnMapping.".concat(type, ".").concat(c)
  }, c))));
}

ColumnMappingSelect.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  availableColumns: _propTypes.default.arrayOf(_propTypes.default.string),
  type: _propTypes.default.oneOf((0, _lodash.keys)(MappingTypes)),
  onChange: _propTypes.default.func
};
ColumnMappingSelect.defaultProps = {
  value: null,
  availableColumns: [],
  type: null,
  onChange: () => {}
};
ColumnMappingSelect.MappingTypes = MappingTypes;
//# sourceMappingURL=ColumnMappingSelect.js.map